import { useAxios } from './useAxios';
import { FormationType, VersionAccount, VersionItem, Account, ProjectCore, VersionAccountStatus } from '../types';

export const useApiService = () => {
    const axiosInstance = useAxios();

    const changeApiUrl = (url: string) => {
        axiosInstance.defaults.baseURL = url;
    };

    const getFormations = async (): Promise<FormationType[]> => {
        const response = await axiosInstance.get('/public_school/formations');

        const versionFormations = await response.data;

        return versionFormations as FormationType[];
    };

    const getFormation = async (id: string): Promise<FormationType> => {
        const response = await axiosInstance.get(`/public_school/formation/${id}`);
        const versionFormation = await response.data;
        return versionFormation as FormationType;
    };

    const getVersionItems = async (id: string): Promise<VersionItem[]> => {
        const response = await axiosInstance.get(`/public_school/formations/${id}/items`);
        const versionItems = await response.data;
        return versionItems as VersionItem[];
    };

    const getVersion = async (id: string): Promise<VersionItem> => {
        const response = await axiosInstance.get(`/school/item/${id}`);
        const version = await response.data;
        return version as VersionItem;
    };

    const getVersionAccountStatus = async (formationId: string, versionId: string): Promise<VersionAccountStatus> => {
        const response = await axiosInstance.get(`/school/formation/${formationId}/version/${versionId}/check_status`);
        const versionStatus = await response.data;

        return versionStatus;
    };

    const checkLessonStatus = async (formationId: string, versionId: string, lessonId: string): Promise<boolean[]> => {
        const response = await axiosInstance.get(
            `/school/formation/${formationId}/version/${versionId}/lesson/${lessonId}/check_lesson_status`
        );
        const lessonStatus = await response.data;

        return lessonStatus;
    };

    const login = async (email: string, password: string): Promise<{ token: string }> => {
        const response = await axiosInstance.post('/login_web', { email, password });
        const credentials = await response.data;

        return credentials;
    };

    const logout = async (): Promise<{ success: boolean }> => {
        const response = await axiosInstance.post('/logout');
        return response.data;
    };

    const getAccountInfos = async (): Promise<Account> => {
        const response = await axiosInstance.get('/school/account');
        return await response.data;
    };

    const getVersionsAccountStatuses = async (): Promise<VersionAccount[]> => {
        const url = '/school/get_versions_by_user';
        const response = await axiosInstance.get(url);
        const finishedVersions = await response.data;
        return finishedVersions;
    };

    const getProjectInfos = async (projectId: string): Promise<ProjectCore> => {
        const response = await axiosInstance.get(`/school/${projectId}/get_tested_project`);
        return await response.data;
    };

    const getProjects = async (): Promise<ProjectCore[]> => {
        const response = await axiosInstance.get('/school/account/projects');
        return await response.data;
    };

    const changeVersionAccountStatusProject = async (accountStatusId: string, projectId: string): Promise<void> => {
        const response = await axiosInstance.put(
            `/school/account/accountstatus/${accountStatusId}/project/${projectId}`,
            {
                accountStatusId: accountStatusId,
                project_id: projectId,
            }
        );

        return response.data;
    };

    return {
        getFormations,
        getFormation,
        getVersionItems,
        getVersion,
        getVersionAccountStatus,
        checkLessonStatus,
        login,
        logout,
        getAccountInfos,
        getVersionsAccountStatuses,
        getProjectInfos,
        getProjects,
        changeVersionAccountStatusProject,
        changeApiUrl,
    };
};
